import LocalStorage from '../../lib/storage/local';
import MemoryStorage from '../../lib/storage/memory';

const createCurrencyStore = () => {
  let store;
  const CURRENCY_STORE_KEY = 'LLV2_REPORTING_CURRENCY'
  const initial = { currency: "CA" };
  if (!process.browser) {
    store = new MemoryStorage(initial);
  } else {
    store = new LocalStorage(CURRENCY_STORE_KEY, initial);
  }
  return store;
}

let currencyStore;
export const getCurrencyStore = () => {
  if (!currencyStore)
    currencyStore = createCurrencyStore();
  return currencyStore;
}